import React from 'react';

const PhilosophySection = () => {
  const content = {
    labelText: "Filosofia",
    title: "Baseado em Ciência e Inovação",
    paragraphs: [
      "A marca Gtechniq tem como objetivo produzir os produtos de cuidado de superfície mais inovadores do mundo. Essa missão surgiu da descoberta de que outros revestimentos aftermarket chamados de \"longa duração\" simplesmente não chegavam perto de suas promessas de marketing.",
      "Se você deseja a melhor proteção para seu carro, barco, avião ou casa, não procure mais. A Gtechniq preenche a lacuna entre inovação e realidade, desenvolvendo os melhores produtos de cuidado de superfície do mundo.",
      "Nossa filosofia é baseada em ciência e inovação, buscando constantemente oferecer soluções que realmente fazem a diferença na proteção e no acabamento das superfícies."
    ],
    imageAlt: "Frascos de produtos Gtechniq",
  };

  return (
    <div className="flex flex-col md:flex-row-reverse bg-[#F3F3F4] md:max-h-[768px]">
      {/* Text content - on top for mobile, on left for desktop */}
      <div className="w-full md:w-2/3 lg:w-1/2 p-8 flex flex-col justify-center md:items-start md:overflow-y-auto">
        <div className="mb-4 relative self-center md:self-start">
          <div className="relative inline-block">
            <span className="bg-[#ff0000] text-white font-semibold px-4 py-1 inline-block relative z-10">
              {content.labelText}
            </span>
            <span 
              className="absolute top-0 left-0 right-0 bottom-0 bg-[#ff0000] transform -skew-x-12 z-0" 
              style={{ 
                width: '100%',
                transformOrigin: 'bottom right'
              }}
            ></span>
          </div>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold mb-4 text-center md:text-left">
          {content.title}
        </h1>
        <div className="text-center md:text-left lg:mt-6 lg:mr-32 md:mt-0 md:mr-0:">
          {content.paragraphs.map((paragraph, index) => (
            <p key={index} className="mb-4 text-gray-700 text-sm md:text-base">
              {paragraph}
            </p>
          ))}
        </div>
      </div>

      {/* Image container - on bottom for mobile, on left for desktop */}
      <div className="w-full md:w-1/3 lg:w-1/2 bg-[#F3F3F4] relative ">
        <picture>
          <source srcSet="/images/background/product-image-about-min.webp" type="image/webp" />
          <img
            src="/images/background/product-image-about-min.png"
            alt={content.imageAlt}
            className="w-full h-full object-cover md:object-contain md:object-bottom relative md:bottom-0 md:mb-0 bottom-24 -mb-24 left-0 "
          />
        </picture>
      </div>
    </div>
  );
};

export default PhilosophySection;
